import apiInstance from "./axios";
import { favorite } from "utils/services/api/schemas";

const favoriteApi = {
  updateFavorite: async (userId, payload) => {
    const response = await apiInstance.put(`${favorite}/${userId}`, payload);
    return response;
  },
  getFavoriteByUserId: async (userId) => {
    const response = await apiInstance.get(`${favorite}/${userId}`);
    return response;
  },
};

export default favoriteApi;
